(() => {
  const form = document.querySelector("[data-tfm-filters]");
  if (!form) return;

  const cards = Array.from(document.querySelectorAll("[data-tfm-product]"));
  const empty = document.querySelector("[data-tfm-filters-empty]");
  const countEl = document.querySelector("[data-tfm-filter-count]");
  const resets = document.querySelectorAll("[data-tfm-filters-reset]");
  const total = cards.length;

  const selected = (name) =>
    Array.from(form.querySelectorAll(`input[name="${name}"]:checked`)).map((el) => el.value);

  const matchesGroup = (selectedValues, cardValues) => {
    if (!selectedValues.length) return true;
    return selectedValues.some((v) => cardValues.includes(v));
  };

  const apply = () => {
    const participants = selected("participants");
    const disponibilite = selected("disponibilite");
    const types = selected("type");
    const active = participants.length + disponibilite.length + types.length > 0;

    let visible = 0;
    cards.forEach((card) => {
      const cardParticipants = (card.getAttribute("data-participants") || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const cardAvail = card.getAttribute("data-disponibilite") || "";
      const cardType = card.getAttribute("data-type") || "";

      const ok =
        matchesGroup(participants, cardParticipants) &&
        matchesGroup(disponibilite, [cardAvail]) &&
        matchesGroup(types, [cardType]);

      card.hidden = !ok;
      card.classList.toggle("tfm-product-card--filtered-out", !ok);
      if (ok) visible += 1;
    });

    resets.forEach((btn) => {
      btn.hidden = !active;
    });
    if (empty) empty.hidden = visible !== 0;

    if (countEl) {
      if (visible === 0) {
        countEl.textContent = "Aucun outil";
      } else if (visible === 1) {
        countEl.textContent = "1 outil";
      } else {
        countEl.textContent = `${visible} outil${visible > 1 ? "s" : ""}${
          active && visible !== total ? ` sur ${total}` : ""
        }`;
      }
    }
  };

  form.addEventListener("change", apply);
  form.addEventListener("input", apply);
  resets.forEach((btn) => {
    btn.addEventListener("click", () => {
      form.querySelectorAll('input[type="checkbox"]').forEach((el) => {
        el.checked = false;
      });
      apply();
    });
  });

  // Apply collection presets (checked in HTML) on load
  apply();
})();
